var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.632,
    height: 36.038,
    viewBox: "0 0 30.632 36.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Paper",
    "data-name": "Iconly/Bold/Paper",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(3.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M17.573,0a.823.823,0,0,1,.821.829h0v5.8a6.034,6.034,0,0,0,5.959,6.018c1.356,0,2.426.018,3.247.018h.3c.548,0,1.287-.017,1.926-.017a.8.8,0,0,1,.8.811h0V27.948a8.05,8.05,0,0,1-8.01,8.091H8.421A8.463,8.463,0,0,1,0,27.551H0V8.127A8.1,8.1,0,0,1,8.046,0h9.527Zm1.909,23.245H9.777a1.339,1.339,0,0,0-1.338,1.333,1.355,1.355,0,0,0,1.338,1.351h9.705a1.355,1.355,0,0,0,1.338-1.351,1.339,1.339,0,0,0-1.338-1.333Zm-3.675-9.01H9.777a1.355,1.355,0,0,0-1.338,1.351A1.339,1.339,0,0,0,9.777,16.92h6.03a1.339,1.339,0,0,0,1.338-1.333,1.355,1.355,0,0,0-1.338-1.351Zm5.187-12.6a.852.852,0,0,1,1.467-.6l7.183,7.545a.859.859,0,0,1-.612,1.454c-1.467.005-3.2,0-4.439-.013a3.635,3.635,0,0,1-3.6-3.634h0Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopee);
export default __webpack_public_path__ + "static/media/shopee.e409c2f1f81b83864754573dde32df55.svg";
export { ForwardRef as ReactComponent };